// extracted by mini-css-extract-plugin
export default {"radio-item":"PollNewUserComponents_radio-item__DU+w2","custom-radio":"PollNewUserComponents_custom-radio__eO-gu","switcher__label":"PollNewUserComponents_switcher__label__C0fEG"};